export default {
	name: "LoaderDots",
	props: {
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
};
